import { __assign, __awaiter, __generator } from "tslib";
import { CartEvents, } from '@wix/wixstores-client-core/dist/es/src/types/cart';
import { Topology, AddToCartActionOption, PageMap } from '@wix/wixstores-client-core/dist/es/src/constants';
import CommandsExecutor from '@wix/wixstores-client-core/dist/es/src/commands-executor';
var CartActions = /** @class */ (function () {
    function CartActions(siteStore, pubSubManager, origin) {
        this.siteStore = siteStore;
        this.pubSubManager = pubSubManager;
        this.origin = origin;
        this.isMiniCartExists = false;
        this.isCartIconExists = false;
        this.commandsExecutor = new CommandsExecutor(Topology.CART_COMMANDS_URL, this.siteStore.httpClient);
        this.trackCartPopupExists();
    }
    /* istanbul ignore next: todo: test */
    // eslint-disable-next-line @typescript-eslint/tslint/config
    CartActions.prototype.addToCart = function (productId, optionsSelections, quantity, customTextFields, addToCartAction, origin, onSuccess, trackingData) {
        if (customTextFields === void 0) { customTextFields = []; }
        if (addToCartAction === void 0) { addToCartAction = AddToCartActionOption.MINI_CART; }
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary, nextTrackingData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendCommandAddToCart(productId, optionsSelections, quantity, customTextFields)];
                    case 1:
                        cartSummary = (_a.sent()).cartSummary;
                        nextTrackingData = (trackingData === null || trackingData === void 0 ? void 0 : trackingData.id) ? __assign(__assign({}, trackingData), { quantity: quantity }) : undefined;
                        return [2 /*return*/, this.onAddToCartCompleted(cartSummary, addToCartAction, origin, onSuccess, nextTrackingData)];
                }
            });
        });
    };
    /* istanbul ignore next: todo: test */
    CartActions.prototype.addItemsToCart = function (addToCartItems, addToCartAction, origin, onSuccess) {
        if (addToCartAction === void 0) { addToCartAction = AddToCartActionOption.MINI_CART; }
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.AddCartItemsCommand(addToCartItems)];
                    case 1:
                        cartSummary = (_a.sent()).cartSummary;
                        return [2 /*return*/, this.onAddToCartCompleted(cartSummary, addToCartAction, origin, onSuccess)];
                }
            });
        });
    };
    CartActions.prototype.shouldNavigateToCart = function () {
        return !this.isMiniCartExists;
    };
    /*istanbul ignore next: todo: test */
    CartActions.prototype.onAddToCartCompleted = function (cartSummary, addToCartAction, origin, onSuccess, trackingData) {
        if (addToCartAction === void 0) { addToCartAction = AddToCartActionOption.MINI_CART; }
        if (addToCartAction === AddToCartActionOption.NONE && !this.isCartIconExists) {
            addToCartAction = AddToCartActionOption.MINI_CART;
        }
        this.saveCart(cartSummary, addToCartAction === AddToCartActionOption.MINI_CART, origin);
        if (onSuccess) {
            onSuccess({ cartId: cartSummary.cartId });
        }
        if (trackingData) {
            this.siteStore.trackEvent('AddToCart', __assign({ cartId: cartSummary.cartId, currency: this.siteStore.currency }, trackingData));
        }
        if (addToCartAction === AddToCartActionOption.CART ||
            (addToCartAction !== AddToCartActionOption.NONE && this.shouldNavigateToCart())) {
            return this.navigateToCart(origin || this.origin);
        }
    };
    CartActions.prototype.trackCartPopupExists = function () {
        var _this = this;
        this.pubSubManager.subscribe('Minicart.LoadedWithoutData', function () {
            _this.isMiniCartExists = true;
        }, true);
    };
    /* istanbul ignore next: todo: test */
    CartActions.prototype.sendCommandAddToCart = function (productId, optionsSelections, quantity, customTextFields) {
        if (customTextFields === void 0) { customTextFields = []; }
        return __awaiter(this, void 0, void 0, function () {
            var postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = {
                            productId: productId,
                            quantity: quantity,
                        };
                        if (Array.isArray(optionsSelections)) {
                            postData.optionsSelections = optionsSelections;
                        }
                        else {
                            postData.optionsSelectionsByNames = optionsSelections;
                        }
                        postData.freeText = customTextFields.map(function (customTextFieldAnswer) {
                            return {
                                title: customTextFieldAnswer.customText.title,
                                value: customTextFieldAnswer.answer,
                            };
                        });
                        return [4 /*yield*/, this.commandsExecutor.execute('AddCartItemCommand', postData)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    /* istanbul ignore next: todo: test */
    CartActions.prototype.AddCartItemsCommand = function (addToCartItems) {
        return __awaiter(this, void 0, void 0, function () {
            var postData, products;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postData = {
                            // @ts-expect-error
                            products: null,
                        };
                        products = addToCartItems.map(function (item) {
                            var options = __assign({ choices: {}, customTextFields: [] }, item.options);
                            var data = {
                                productId: item.productId,
                                quantity: item.quantity,
                                freeText: options.customTextFields,
                            };
                            if (Array.isArray(options.choices)) {
                                data.optionsSelections = options.choices;
                            }
                            else {
                                data.optionsSelectionsByNames = options.choices;
                            }
                            return data;
                        });
                        postData.products = products;
                        return [4 /*yield*/, this.commandsExecutor.execute('AddCartItemsCommand', postData)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    /* istanbul ignore next: todo: test */
    CartActions.prototype.saveCart = function (cartSummary, shouldOpenMiniCart, origin) {
        if (shouldOpenMiniCart === void 0) { shouldOpenMiniCart = true; }
        cartSummary.extraParams = { origin: origin || this.origin };
        cartSummary.eventOptions = { shouldOpenCart: shouldOpenMiniCart };
        delete cartSummary.billingAddress;
        delete cartSummary.shippingAddress;
        this.pubSubManager.publish(CartEvents.CHANGED, cartSummary);
    };
    /* istanbul ignore next: todo: test */
    CartActions.prototype.setCartIconExist = function () {
        this.isCartIconExists = true;
    };
    /* istanbul ignore next: todo: test */
    CartActions.prototype.navigateToCart = function (origin) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.siteStore.navigate({
                        sectionId: PageMap.CART,
                        queryParams: { origin: origin },
                    }, true)];
            });
        });
    };
    CartActions.prototype.removeItemFromCart = function (cartItemId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandsExecutor.execute('RemoveCartItemCommand', {
                            cartItemId: cartItemId,
                        })];
                    case 1:
                        response = _a.sent();
                        this.saveCart(response.data.cartSummary, false, 'corvid');
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    CartActions.prototype.addCustomItemsToCart = function (customItems) {
        return __awaiter(this, void 0, void 0, function () {
            var customAmounts, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        customAmounts = customItems.map(function (item) {
                            return {
                                name: item.name,
                                notes: item.note,
                                quantity: item.quantity,
                                amount: item.price,
                            };
                        });
                        return [4 /*yield*/, this.commandsExecutor.execute('BulkAddDetailedCustomAmountV2', {
                                amounts: customAmounts,
                            })];
                    case 1:
                        response = _a.sent();
                        this.saveCart(response.data.cartSummary, false, 'corvid');
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    CartActions.prototype.applyCouponToCart = function (couponCode) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandsExecutor.execute('SetCartCouponCommand2', {
                            code: couponCode,
                        })];
                    case 1:
                        response = _a.sent();
                        this.saveCart(response.data.cartSummary, false, 'corvid');
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    CartActions.prototype.removeCouponFromCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandsExecutor.execute('RemoveCouponFromCartCommand', {})];
                    case 1:
                        response = _a.sent();
                        this.saveCart(response.data.cartSummary, false, 'corvid');
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    CartActions.prototype.updateLineItemQuantityInCart = function (cartItemId, quantity) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandsExecutor.execute('UpdateCartItemCommand', {
                            cartItemId: cartItemId,
                            quantity: quantity,
                        })];
                    case 1:
                        response = _a.sent();
                        this.saveCart(response.data.cartSummary, false, 'velo');
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    CartActions.prototype.addProductsToCart = function (products) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.AddCartItemsCommand(products)];
                    case 1:
                        data = _a.sent();
                        this.saveCart(data.cartSummary, false, 'velo');
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return CartActions;
}());
export { CartActions };
//# sourceMappingURL=CartActions.js.map